import DOMPurify from 'dompurify';

DOMPurify.setConfig({
  ALLOWED_TAGS: ['a'],
  ALLOWED_ATTR: ['href', 'target', 'rel'],
});

export default DOMPurify;
